import React from 'react';

const PrivacyPolicyContent = () => (
    <div className="space-y-8 text-gray-700 leading-relaxed text-sm md:text-base">
        <div className="text-center border-b pb-6">
            <h2 className="text-xl font-bold text-[#1B5125] uppercase tracking-wide">
                Polityka Prywatności i Plików Cookie
            </h2>
            <p className="text-gray-500 mt-2">strony www.fedyszyn-olszewska.pl</p>
        </div>

        <p className="font-medium">
            Polityka prywatności określa zasady przetwarzania oraz gromadzenia danych osobowych pozyskanych za pośrednictwem serwisu fedyszyn-olszewska.pl
        </p>

        <section>
            <h3 className="flex items-center text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§1</span> INFORMACJE OGÓLNE
            </h3>
            <p className="mb-4">
                Administratorem danych osobowych jest <strong>Olga Fedyszyn-Olszewska</strong> prowadząca jednoosobową działalność gospodarczą pod nazwą <strong>KANCELARIA ADWOKACKA ADWOKAT OLGA FEDYSZYN-OLSZEWSKA</strong> z siedzibą przy Al. Tadeusza Kościuszki 93 /14 90-436 Łódź, NIP: 7262714626, REGON: 542606220.
            </p>
            <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-[#1B5125]">
                <p className="font-semibold mb-1">Kontakt w sprawach ochrony danych:</p>
                <p>Adres email: <a href="mailto:kancelaria@fedyszyn-olszewska.pl" className="text-[#1B5125] underline">kancelaria@fedyszyn-olszewska.pl</a></p>
                <p>Numer telefonu: <a href="tel:+48662276973" className="text-[#1B5125] underline">+48 662 276 973</a></p>
            </div>
            <p className="mt-4">
                Administrator przetwarza dane osobowe zgodnie z RODO oraz krajowymi przepisami prawa. Kancelaria zachowuje dane w poufności i zabezpiecza je przed niepowołanym dostępem.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§2</span> PRZETWARZANIE DANYCH OSOBOWYCH
            </h3>
            <p className="mb-3">Zakres danych obejmuje: <strong>imię i nazwisko, adres e-mail oraz treść wiadomości / opis sprawy.</strong></p>
            <p>
                Podanie danych jest <strong>dobrowolne</strong>, jednak niezbędne do skorzystania z funkcji wysłania wiadomości za pośrednictwem formularza kontaktowego. Dane mogą być udostępnione wyłącznie podmiotom współpracującym na podstawie przepisów prawa.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§3</span> PODSTAWA PRAWNA PRZETWARZANIA
            </h3>
            <ul className="list-disc pl-5 space-y-2">
                <li>Udzielenie odpowiedzi (art. 6 ust. 1 lit. a RODO – zgoda).</li>
                <li>Wykonanie umowy lub działania przedumowne (art. 6 ust. 1 lit. b RODO).</li>
                <li>Wypełnienie obowiązków prawnych (art. 6 ust. 1 lit. c RODO).</li>
            </ul>
        </section>

        <section>
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§4</span> CZAS PRZECHOWYWANIA DANYCH
            </h3>
            <p>
                Dane osobowe przesłane przez formularz kontaktowy są przechowywane przez okres niezbędny do prowadzenia korespondencji, a następnie maksymalnie przez <strong>12 miesięcy</strong> w celach dowodowych. Dane przetwarzane na podstawie zgody są przechowywane do czasu jej wycofania przez Użytkownika.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§5</span> ODBIORCY DANYCH
            </h3>
            <p className="mb-3">
                Dane osobowe klienta mogą być przekazywane podmiotom wspierającym Administratora w zakresie obsługi technicznej strony internetowej, wyłącznie w zakresie niezbędnym do utrzymania strony i infrastruktury hostingowej.
            </p>
            <p>
                Dane <strong>nie będą przekazywane poza Europejski Obszar Gospodarczy (EOG)</strong>, chyba że nastąpi to w oparciu o zgodę klienta, standardowe klauzule umowne lub inne zabezpieczenia przewidziane w RODO.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§6</span> PRAWA OSÓB, KTÓRYCH DANE DOTYCZĄ
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 text-sm text-[#1B5125]">
                <p>• Dostęp do danych</p>
                <p>• Sprostowanie</p>
                <p>• Usunięcie (zapomnienie)</p>
                <p>• Ograniczenie</p>
                <p>• Przenoszenie</p>
                <p>• Sprzeciw</p>
                <p>• Cofnięcie zgody</p>
            </div>
        </section>

        <section>
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§7</span> PLIKI COOKIES I NARZĘDZIA ANALITYCZNE
            </h3>
            <p>
                Administrator korzysta z narzędzia <strong>Google Analytics</strong> oraz <strong>Google Tag Manager</strong>, dostarczanego przez Google Ireland Limited z siedzibą w Dublinie. Użytkownik może w każdej chwili zmienić ustawienia plików cookies w swojej przeglądarce internetowej.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§8</span> ZABEZPIECZENIE DANYCH
            </h3>
            <p>
                Administrator stosuje odpowiednie środki techniczne i organizacyjne zapewniające ochronę danych osobowych przed nieuprawnionym dostępem, utratą, zniszczeniem lub nieuprawnionym ujawnieniem. Środki te są na bieżąco dostosowywane do poziomu ryzyka.
            </p>
        </section>

        <section className="pb-4">
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§9</span> ZMIANY W POLITYCE PRYWATNOŚCI
            </h3>
            <p>
                Administrator zastrzega sobie prawo do wprowadzania zmian w niniejszej Polityce prywatności, w szczególności w celu dostosowania jej do zmian w przepisach prawa lub w funkcjonowaniu strony internetowej.
            </p>
        </section>
    </div>
);

export default PrivacyPolicyContent;